import React from 'react'
import './BBExpressDownload.css'
function Expressdownload() {
    let tNCText = "Please Select the Platform to Download"
   
      return (
        <>
          <div className='container termsNCondSection'>
  
            <div className='headingSection'>
              <h2>Bani Bayani App Download</h2>
            </div>
  
            <div className='mainbodysection'>
              {tNCText}
            </div>

            <div className='select-platform'>
              <a className='select-platform-button' href='https://apps.apple.com/ng/app/bani-bayani/id1341372776'>App Store</a>
            </div>

            <div className='select-platform'>
              <a className='select-platform-button' href='https://play.google.com/store/apps/details?id=com.ybcodelab.banibayani&pcampaignid=web_share'>Google Play Store</a>
            </div>
  
  
           </div>
        </>
      )
  }
  
  export default Expressdownload